import { useState } from "react";

import { Container, Form, InputGroup, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { Button } from "primereact/button";

import Dot from "../../../assets/svg/Dot";
import { EyeIcon, EyeSlashIcon } from "../../../assets/svg/Eye";
import DwellLogo from "../../../common/components/DwellLogo";
import history from "../../../routes/history.ts";
import { resetPassword } from "../services";



const ResetPasswordContainer = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const {
    handleSubmit,
    register,
    watch,
    formState: { isValid, isSubmitting },
  } = useForm();

  const [passwordVisibility, setPasswordVisibility] = useState(false);

  if (!token) {
    history.push("/login");
    return;
  }
  const onSubmit = async (data: any) => {
    try {
      await resetPassword(data.password, token!);
      toast.success("Votre mot de passe a été réinitialisé");
      history.push("/login");
    } catch (e: any) {
      if (e.response.status === 401) {
        toast.error("Le jeton de réinitialisation est invalide ou expiré.");
      } else {
        toast.error(
          "Impossible de réinitialiser votre mot de passe.\nVeuillez contacter votre administrateur système.",
        );
      }
    }
  };

  return (
    <div>
      <Container className="d-flex flex-column min-vh-100 justify-content-center align-items-center flex-wrap ">
        <Row className="align-items-center justify-content-center register-form">
          <h3 className="text-center mb-0 fw-bold register-title mb-4">
            Réinitialisez votre mot de passe
          </h3>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-2" controlId="password">
              <InputGroup className="d-flex flex-row justify-content-start mb-3">
                <Form.Control
                  {...register("password", {
                    required: true,
                    pattern: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}/,
                  })}
                  className="mr-2"
                  type={passwordVisibility ? "text" : "password"}
                  placeholder="Nouveau mot de passe"
                  autoComplete="new-password"
                  disabled={isSubmitting}
                />
                <Button
                  className="h-auto"
                  icon={passwordVisibility ? <EyeSlashIcon /> : <EyeIcon />}
                  onClick={() => setPasswordVisibility(!passwordVisibility)}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="mb-4" controlId="passwordFeedback">
              <div className="d-flex flex-row justify-content-evenly mt-0">
                <div className="d-flex flex-column justify-content-start">
                  <p className="register-info mb-0">
                    <Dot
                      color={
                        watch("password") && /[A-Z]/.test(watch("password"))
                          ? " lime "
                          : " grey "
                      }
                    />
                    Une majuscule
                  </p>
                  <p className="register-info mt-0">
                    <Dot
                      color={
                        watch("password") && /[a-z]/.test(watch("password"))
                          ? " lime "
                          : " grey "
                      }
                    />
                    Une minuscule
                  </p>
                </div>
                <div className="d-flex flex-column justify-content-start">
                  <p className="register-info mb-0">
                    <Dot
                      color={
                        watch("password") && /[0-9]/.test(watch("password"))
                          ? " lime "
                          : " grey "
                      }
                    />
                    Un chiffre
                  </p>
                  <p className="register-info mt-0">
                    <Dot
                      color={
                        watch("password") && watch("password").length >= 8
                          ? " lime "
                          : " grey "
                      }
                    />
                    8 caractères
                  </p>
                </div>
              </div>
            </Form.Group>
            <div className="text-center">
              <Button
                label="Réinitialiser le mot de passe"
                icon="pi pi-check"
                loading={isSubmitting}
                disabled={!isValid}
              />
            </div>
          </Form>
        </Row>
      </Container>
      <div className="position-absolute top-0 start-0 p-3">
        <DwellLogo linkTo="/home" />
      </div>
    </div>
  );
};
export default ResetPasswordContainer;
